import React from 'react'

import { usePrevious } from 'hooks'
import {
  PRODUCTIVITY_FIELD,
  SICKNESS_ABSENCE_FIELD,
  TURNOVER_FIELD,
  NO_PRIORITY_FIELD,
} from './model'

export const useInterdependantFields = (state, setValue) => {
  const { absence, productivity, turnover, noPriority } = state

  const previousNoPriority = usePrevious(noPriority)
  const previousAbsence = usePrevious(absence)
  const previousProductivity = usePrevious(productivity)
  const previousTurnover = usePrevious(turnover)

  React.useEffect(() => {
    if (absence && !previousAbsence) {
      if (productivity) setValue(PRODUCTIVITY_FIELD, false)
      if (turnover) setValue(TURNOVER_FIELD, false)
      if (noPriority) setValue(NO_PRIORITY_FIELD, false)
      return
    }

    if (productivity && !previousProductivity) {
      if (absence) setValue(SICKNESS_ABSENCE_FIELD, false)
      if (turnover) setValue(TURNOVER_FIELD, false)
      if (noPriority) setValue(NO_PRIORITY_FIELD, false)
      return
    }

    if (turnover && !previousTurnover) {
      if (absence) setValue(SICKNESS_ABSENCE_FIELD, false)
      if (productivity) setValue(PRODUCTIVITY_FIELD, false)
      if (noPriority) setValue(NO_PRIORITY_FIELD, false)
      return
    }

    if (noPriority && !previousNoPriority) {
      if (absence) setValue(SICKNESS_ABSENCE_FIELD, false)
      if (productivity) setValue(PRODUCTIVITY_FIELD, false)
      if (turnover) setValue(TURNOVER_FIELD, false)
      return
    }
  }, [absence, productivity, turnover, noPriority])
}
